module.exports = __webpack_public_path__ + "img/ae-6.0a4f132.png";